import { localTime } from '@/utils/utc-time';

import { formatTimestamp } from '../../../utils';

export const calculateLatency = (start: string, end: string) => {
  const latency = `${calculateLatencyNumber(start, end).toFixed(2)}s`;
  return {
    start: formatTimestamp(start),
    end: formatTimestamp(end),
    latency: latency,
  };
};

export const calculateLatencyNumber = (start: string, end: string) => {
  const startTime = localTime(start);
  const endTime = end.length > 0 ? localTime(end) : startTime;
  const latency = endTime.diff(startTime, 's', true);
  return latency;
};
